import React, { useEffect, useRef, useState } from "react";
import { Box } from "@mui/material";

/**
 * Mounts children only once they approach the viewport.
 * Keeps a placeholder height so InfiniteScroll layout stays stable.
 */
const LazyFeedItem = ({ children, rootMargin = "600px 0px", minHeight = 320 }) => {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (visible) return undefined;
    const el = ref.current;
    if (!el) return undefined;

    if (typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return undefined;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { root: null, rootMargin, threshold: 0.01 },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [visible, rootMargin]);

  return (
    <Box
      ref={ref}
      sx={{
        minHeight: visible ? undefined : minHeight,
        width: "100%",
        contentVisibility: "auto",
        containIntrinsicSize: `auto ${minHeight}px`,
      }}
    >
      {visible ? children : null}
    </Box>
  );
};

export default LazyFeedItem;
